import tinycolor from 'tinycolor2';
import { TStateRetriever, TActionDefinition } from '../types';
import { getValueByPath } from '../util';

/**
 * Este método acepta un objeto con backgroundColor y borderColor y aplica el
 * estado pasado como segundo parámetro de la siguiente manera:
 *
 * Si se pasa backgroundColor, se devuelve un backgroundColor y un color, que
 * corresponden al backgroundColor con el estado aplicado y un color calculado
 * con la función getContrastText.
 *
 * Si se pasa borderColor, se devuelve un nuevo borderColor calculado con el
 * estado aplicado.
 */
const getColorState: TStateRetriever = (definition, state, palette) => {
  if (state === 'default') return palette.buildColorsObject(definition);

  const opacity: number = palette.action[
    `${state}Opacity` as keyof TActionDefinition
  ] as number;

  const actualState = state === 'checked' ? 'selected' : state;

  // eslint-disable-next-line no-param-reassign
  definition = Object.fromEntries(
    Object.entries(definition).map(([name, value]) => {
      if (
        [
          'backgroundColor',
          'borderColor',
          'borderLeftColor',
          'borderRightColor',
          'borderBottomColor',
          'borderTopColor',
          'color',
        ].includes(name) &&
        ((value ?? '') as string).startsWith('palette')
      )
        // eslint-disable-next-line no-param-reassign
        value = getValueByPath(
          palette,
          (value as string).slice('palette.'.length),
        ) as string;

      return [name, value];
    }),
  );

  const calculatedBackgroundColor = tinycolor
    .mix(
      (definition.backgroundColor ?? '') as string,
      tinycolor((definition.backgroundColor ?? '') as string).isLight()
        ? palette.action[actualState].light
        : palette.action[actualState].dark,
      100 * opacity,
    )
    .toRgbString();

  return palette.buildColorsObject({
    ...(definition.backgroundColor
      ? {
          backgroundColor:
            state === 'checked'
              ? definition.backgroundColor ?? ''
              : calculatedBackgroundColor,
          color:
            state === 'checked'
              ? tinycolor
                  .mix(
                    tinycolor((definition.color ?? 'black') as string),
                    tinycolor(palette.action.selected.dark),
                    100 * palette.action.selectedOpacity,
                  )
                  .toRgbString()
              : palette.getContrastText(calculatedBackgroundColor),
        }
      : null),
    ...(definition.borderColor
      ? {
          borderColor: tinycolor
            .mix(
              definition.borderColor as string,
              tinycolor(definition.borderColor as string).isLight()
                ? palette.action[actualState].light
                : palette.action[actualState].dark,
              100 * opacity,
            )
            .toRgbString(),
        }
      : null),
  });
};
export default getColorState;
